var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"modall",staticClass:"modal fade",class:{
		'modal-center': _vm.show && _vm._isMobile
	},style:({'z-index': _vm.index}),attrs:{"id":"modal-template","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",style:({width: _vm.width}),attrs:{"role":"document"}},[_c('div',{class:{
				'modal-content': !_vm.transparent
			},staticStyle:{"padding":"14px","display":"relative"}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }